import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...p }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...p}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-orange-400 font-bold">
    {children}
  </p>
);

export const SectionShell = ({ id, children, className = "" }) => (
  <section id={id} className={`relative w-full scroll-mt-24 ${className}`}>
    <div className="mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-12">{children}</div>
  </section>
);
